import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const AnppPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#F9FFEF',
            100: '#f0fadb',
            200: '#dff5b0',
            300: '#c8ec7a',
            400: '#aad95a',
            500: '#8EBF3D', // color-light-green
            600: '#74a530',
            700: '#5a8a24',
            800: '#087D40', // color-green
            900: '#065c2f',
            950: '#033d1f'
        },
        colorScheme: {
            light: {
                primary: {
                    color: '#8EBF3D',
                    contrastColor: '#ffffff',
                    hoverColor: '#74a530'
                }
            }
        }
    },
    components: {
        button: {
            root: {
                primary: {
                    background: '{primary.500}',
                    borderColor: '{primary.500}',
                    color: '#ffffff',
                    hoverBackground: '{primary.800}',
                    hoverBorderColor: '{primary.800}',
                    hoverColor: '#ffffff'
                }
            },
            outlined: {
                primary: {
                    hoverBackground: '{primary.800}',
                    activeBackground: '{primary.50}',
                    borderColor: '{primary.800}',
                    color: '{primary.800}'
                }
            }
        },
        checkbox: {
            root: {
                checkedBackground: '{primary.500}',
                checkedBorderColor: '{primary.500}',
                checkedHoverBackground: '{primary.800}',
                checkedHoverBorderColor: '{primary.800}'
            }
        },
        datatable: {
            headerCell: {
                background: '{primary.50}',
                color: '{primary.800}',
                hoverBackground: '{primary.50}',
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.500}'
            },
            sortIcon: {
                color: '{primary.800}',
                hoverColor: '{primary.500}'
            },
            filter: {
                constraint: {
                    selectedBackground: '{primary.50}',
                    selectedFocusBackground: '{primary.50}',
                    selectedColor: '{primary.500}',
                    selectedFocusColor: '{primary.500}'
                }
            }
        },
        datepicker: {
            date: {
                selectedBackground: '{primary.800}',
                rangeSelectedBackground: '{primary.50}'
            }
        },
        floatlabel: {
            root: {
                focusColor: '{primary.800}'
            }
        },
        inputtext: {
            root: {
                borderColor: '{primary.800}',
                focusBorderColor: '{primary.800}'
            }
        },
        multiselect: {
            root: {
                borderColor: '{primary.800}',
                focusBorderColor: '{primary.800}'
            },
            dropdown: {
                color: '{primary.800}'
            },
            option: {
                focusBackground: '{primary.50}',
                focusColor: '{primary.800}',
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.800}',
                selectedFocusBackground: '{primary.50}',
                selectedFocusColor: '{primary.800}'
            }
        },
        paginator: {
            navButton: {
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.800}',
                hoverBackground: '{primary.50}',
                hoverColor: '{primary.800}'
            }
        },
        select: {
            root: {
                borderColor: '{primary.800}',
                focusBorderColor: '{primary.800}'
            },
            dropdown: {
                color: '{primary.800}'
            },
            option: {
                focusBackground: '{primary.50}',
                focusColor: '{primary.800}',
                selectedBackground: '{primary.50}',
                selectedColor: '{primary.800}',
                selectedFocusBackground: '{primary.50}',
                selectedFocusColor: '{primary.800}'
            },
            checkmark: {
                color: '{primary.800}'
            }
        }
    }
});
